// import PropTypes from 'prop-types';
// import { useParams } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { OnboardingSidebar } from 'components';

/**
 * Container to manage the sidebar rendering and interactions.
 */
const SidebarContainer = () => 
  // const { uuid } = useParams();
  // TODO: Add sidebar reducer to track currentPage
  // const { currentPage } = useSelector(({ sidebarReducer }) => sidebarReducer);

   <OnboardingSidebar />
;

// SidebarContainer.propTypes = {
//   match: PropTypes.object.isRequired,
// };

export default SidebarContainer;
